import React from 'react';
import OnboardingTour from './views/OnboardingTour'

const Onbording = () => {
  return (<OnboardingTour />)
}

export default Onbording
